import React from 'react';
import ContentLoader from 'react-content-loader';

const CalendarSkeleton: React.FC = () => {
  return (
    <div className="d-flex-center">
      <div className="d-flex-center pt-0_5rem">
        <ContentLoader
          speed={1.5}
          width={45}
          height={16}
          viewBox="0 0 45 16"
          backgroundColor="#efefef"
          foregroundColor="#b1b3b5"
        >
          <rect x="0" y="0" rx="2" ry="2" width="45" height="16" />
        </ContentLoader>
      </div>
    </div>
  );
};

export default CalendarSkeleton;
